<template lang="html">
  <div class="service-content fixed-content">
    <filterTab
      :citycode="citycode"
      heightClass="h800"
      v-on:doSearch="searchData"
    ></filterTab>
    <loadData
      viewName="servicesSkuList"
      :fetchData="serviceList"
      :fetchMethod="getCateSkus"
      :controlPage="changePage"
      :page="pageNo"
      :pageSize="pageSize"
      :firstFetch="firstFetch"
      :hasErr="hasErr"
      :otherParams="{ errText: '当前区域暂不支持该服务项目<br>敬请期待' }"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import empty from '@/components/common/empty'

import loadData from '@/components/loadMore'
import filterTab from '@/components/product/filter'

export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit('hideActionSheet')
    })
  },
  data() {
    return {
      title: '',
      pageNo: 1,
      pageSize: 50,
      firstFetch: true,
      hasErr: false,
      citycode: '320100',
      binary: '',
      searchId: '',
      provinceLevelCity: ['110100', '120100', '310100', '500100']
    }
  },
  async created() {
    const device = this.$$getDevice()
    const isMobile = device === 'ios' || device === 'android'
    this.citycode = this.$route.query.citycode || '320100'
    const citycode_h5 = this.$$cookie('citycode_h5') || ''
    if (citycode_h5) {
      // 兼容cms活动页中的选择地址
      this.citycode = citycode_h5 // cms中活动页地址选择直辖市给的是市辖区的code
      if (this.provinceLevelCity.includes(this.citycode)) {
        this.citycode = `${this.citycode.substr(0, 2)}0000`
      }
    }
    this.binary = this.$route.params.cateId || ''
    this.searchId = this.$route.params.searchId || ''
    if (this.binary) {
      this.title = this.$route.query.name || '特色服务'
      const cate = {
        categoryId: this.binary,
        categoryName: this.$route.query.name
      }
      this.setFilterService([cate])
      this.getAllCate()
      this.getCateSkus(this.binary)
    } else {
      this.getCateTwo()
      const catename =
        decodeURIComponent(this.$route.query.catename) || '特色项目'
      // this.getCateSkus()
      this.title = catename
    }
    this.$$title(this.title)
    this.$$share({
      title: `孩子王为您提供${this.title}`,
      desc: '专业服务，品质生活认准孩子王育儿服务平台'
    })
  },
  mounted() {
    try {
      window.kwapp.allowRefreshOrShare(false, false)
    } catch (e) {
      if (window.kwapp && window.kwapp.onReady) {
        window.kwapp.onReady(() => {
          window.kwapp.allowRefreshOrShare(false, false)
        })
      }
    }
  },
  methods: {
    ...mapMutations(['setServiceTypeList', 'setFilterService']),
    async getAllCate() {
      const json = await this.$store.dispatch('getCategoryList', {})
      if (json && json.length > 0) {
        this.setServiceTypeList(json)
      }
    },
    async getCateTwo() {
      try {
        if (this.fetching) {
          return
        }
        this.fetching = true
        const cateOneId = this.searchId
        const citycode = this.citycode
        const res = await this.$store.dispatch('getCateTwo', {
          citycode,
          cateOneId
        })
        if (res.code === '0') {
          this.secondCates = res.content.result.serveItems || []
          if (this.secondCates.length > 0) {
            // this.changeTab(this.secondCates[0])
            const arr = []
            this.secondCates.forEach(v => {
              const obj = {
                categoryId: v.binary,
                categoryName: v.name
              }
              arr.push(obj)
            })
            this.setServiceTypeList(arr)
            this.setFilterService([arr[0]])
          }
        } else {
          this.$$toast(res.msg)
        }
        this.fetching = false
      } catch (e) {
        this.fetching = false
      }
    },
    async getCateSkus(binary) {
      if (!binary) {
        const categoryId =
          this.filterService &&
          this.filterService[0] &&
          this.filterService[0].categoryId
        binary = categoryId || ''
      }
      try {
        const res = await this.$store.dispatch('getCateOrCitySkus', {
          citycode: this.citycode,
          binary,
          pageSize: this.pageNo,
          pageLength: this.pageSize,
          districtId:
            this.serverArea && this.serverArea[0] && this.serverArea[0].ID,
          isSelf: this.filterSelf - 0,
          businessId:
            this.filterBusiness &&
            this.filterBusiness[0] &&
            this.filterBusiness[0].businessId
        })
        if (res.code === '1') {
          this.hasErr = false
        } else {
          this.$$toast(res.msg)
          this.hasErr = true
        }
        this.firstFetch = false
      } catch (e) {
        this.firstFetch = false
        this.$$toast('网络异常，请刷新重试')
        this.hasErr = true
      }
      this.$$loading(false)
    },
    changePage(pageNo) {
      this.pageNo = pageNo
    },
    searchData() {
      console.log('doSearch')
      this.pageNo = 1
      const categoryId =
        this.filterService &&
        this.filterService[0] &&
        this.filterService[0].categoryId
      this.getCateSkus(categoryId)
    }
  },
  components: {
    loadData,
    empty,
    filterTab
  },
  computed: {
    ...mapState({ serviceList: 'serviceListByCate' }),
    ...mapState(['serverArea', 'filterService', 'filterSelf', 'filterBusiness'])
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.service-content {
  // margin-top: rem(20px);
}

.fixedTop {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
